var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BalanceAndTransactions',{attrs:{"apiGetTransactionsAndBalance":_vm.$api.transaction.getTransactionsAndBalance,"workerId":_vm.user.user_id,"initializedOnPelican":false}})}
var staticRenderFns = []

export { render, staticRenderFns }